function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * This appears to hold the core code for connecting to peers over stun
 *
 */
var StreamManager = /*#__PURE__*/function () {
  function StreamManager(app, mod, settings) {
    var _this = this;
    _classCallCheck(this, StreamManager);
    this.app = app;
    this.mod = mod;
    this.localStream = null; //My Video Feed
    this.presentationStream = null;
    this.remoteStreams = new Map(); //The video of the other parties
    this.transcribingPeers = new Set();
    this.videoEnabled = true;
    this.audioEnabled = true;
    this.videoSource = null;
    this.audioSource = null;
    this.auto_disconnect = false;
    this.active = true;
    this.monitors = {};
    this.parseSettings(settings);
    app.connection.on('stun-toggle-video', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this$localStream$get, newLocalStream, videoTrack, _this$mod$diagnostics, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (_this.active) {
              _context.n = 1;
              break;
            }
            console.warn('TALK [stun-toggle] event when not active...');
            return _context.a(2);
          case 1:
            if (!(_this.videoEnabled === true)) {
              _context.n = 3;
              break;
            }
            if (_this.localStream.getVideoTracks()[0]) {
              _context.n = 2;
              break;
            }
            return _context.a(2);
          case 2:
            _this.localStream.getVideoTracks()[0].enabled = false;
            _this.videoEnabled = false;
            _context.n = 9;
            break;
          case 3:
            // Turn on Video

            _this.videoEnabled = true;
            if ((_this$localStream$get = _this.localStream.getVideoTracks()) !== null && _this$localStream$get !== void 0 && _this$localStream$get.length) {
              _context.n = 8;
              break;
            }
            _context.p = 4;
            _context.n = 5;
            return navigator.mediaDevices.getUserMedia(_this.returnConstraints(true));
          case 5:
            newLocalStream = _context.v;
            videoTrack = newLocalStream.getVideoTracks()[0];
            _this.localStream.addTrack(videoTrack);

            // Add new track to the local stream
            _this.app.connection.emit('videocall-stream', 'local', _this.localStream);
            _this.app.connection.emit('add-local-stream-request', _this.localStream);
            _this.mod.stun.peers.forEach(function (peerConnection, key) {
              console.info('TALK [stun-toggle-video] -- Attach new video to: ' + key);
              if (_this.mod.room_obj.call_peers.includes(key)) {
                var videoSenders = peerConnection.getSenders().filter(function (sender) {
                  return sender.track && sender.track.kind === 'video';
                });
                if (videoSenders.length > 0) {
                  console.warn('TALK [stun-toggle-video]: replacing tracks!');
                  videoSenders.forEach(function (sender) {
                    sender.replaceTrack(videoTrack);
                  });
                } else {
                  peerConnection.addTrack(videoTrack);
                }
              }
            });
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t = _context.v;
            (_this$mod$diagnostics = _this.mod.diagnostics) === null || _this$mod$diagnostics === void 0 || _this$mod$diagnostics.record('local', "Enable camera failed: ".concat(_t.name));
            console.error('TALK [stun-toggle-video] ERROR:', _t);
          case 7:
            _context.n = 9;
            break;
          case 8:
            _this.localStream.getVideoTracks()[0].enabled = true;
          case 9:
            data = {
              enabled: _this.videoEnabled,
              public_key: _this.mod.publicKey
            };
            _this.mod.sendOffChainMessage('toggle-video', data);
          case 10:
            return _context.a(2);
        }
      }, _callee, null, [[4, 6]]);
    })));
    app.connection.on('stun-toggle-audio', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var data;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (_this.active) {
              _context2.n = 1;
              break;
            }
            console.warn('TALK [stun-toggle] event when not active...');
            return _context2.a(2);
          case 1:
            _this.audioEnabled = !_this.audioEnabled;
            _this.localStream.getAudioTracks().forEach(function (track) {
              track.enabled = _this.audioEnabled;
            });
            data = {
              public_key: _this.mod.publicKey,
              enabled: _this.audioEnabled
            };
            _this.app.connection.emit('peer-toggle-audio-status', {
              enabled: _this.audioEnabled,
              public_key: 'local'
            });
            _this.mod.sendOffChainMessage('toggle-audio', data);
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    })));
    app.connection.on('begin-share-screen', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _this$mod$diagnostics2, _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            if (_this.active) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            _context3.p = 1;
            _context3.n = 2;
            return navigator.mediaDevices.getDisplayMedia({
              video: true,
              audio: true,
              selfBrowserSurface: 'include',
              monitorTypeSurfaces: 'include',
              systemAudio: 'include'
            });
          case 2:
            _this.presentationStream = _context3.v;
            _this.presentationStream.getVideoTracks()[0].onended = _this.endPresentation.bind(_this);
            _this.mod.screen_share = true;
            _context3.n = 3;
            return _this.mod.sendOffChainMessage('screen-share-start', {});
          case 3:
            /// emit event to make presentation be the large screen and make presentation mode on
            _this.app.connection.emit('add-remote-stream-request', 'presentation', _this.presentationStream);
            console.debug('TALK [begin-screen-share]: ', _this.mod.room_obj.call_peers, _this.mod.stun.peers);
            _this.mod.stun.peers.forEach(function (pc, key) {
              if (_this.mod.room_obj.call_peers.includes(key)) {
                _this.presentationStream.getTracks().forEach(function (track) {
                  pc.addTrack(track, _this.presentationStream);
                });
                // for (let track of this.presentationStream.getTracks()) {
                //   console.log('tracks added', track)
                //   pc.addTrack(track);
                // }
              }
            });
            _this.app.connection.emit('toggle-screen-share-label', true);
            _context3.n = 5;
            break;
          case 4:
            _context3.p = 4;
            _t2 = _context3.v;
            (_this$mod$diagnostics2 = _this.mod.diagnostics) === null || _this$mod$diagnostics2 === void 0 || _this$mod$diagnostics2.record('local', "Screen capture failed: ".concat(_t2.name));
            console.error('TALK [begin-screen-share]: Error:', _t2);
          case 5:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 4]]);
    })));
    app.connection.on('stop-share-screen', function () {
      if (!_this.active) {
        return;
      }
      _this.endPresentation();
    });
    app.connection.on('stun-connection-connected', function (peerId) {
      var _this$mod;
      if (!_this.active) {
        return;
      }
      console.debug('TALK [stun-connection-connected] ', _this.active, peerId);
      if (!((_this$mod = _this.mod) !== null && _this$mod !== void 0 && _this$mod.room_obj) || !_this.mod.room_obj.call_peers.includes(peerId)) {
        return;
      }
      var pc = _this.mod.stun.peers.get(peerId);
      if (pc.firstConnect) {
        var sound = new Audio('/saito/sound/Polite.mp3');
        sound.play();
        pc.firstConnect = false;
      }
      _this.mod.sendOffChainMessage('toggle-audio', {
        public_key: _this.mod.publicKey,
        enabled: _this.audioEnabled
      });
      _this.mod.sendOffChainMessage('toggle-video', {
        public_key: _this.mod.publicKey,
        enabled: _this.videoEnabled
      });
      _this.broadcastTranscriptionStatus();

      // Add connection quality monitoring....
      if (_this.monitors[peerId]) {
        clearInterval(_this.monitors[peerId]);
        delete _this.monitors[peerId];
      }
      var my_stats = {};
      _this.monitors[peerId] = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var stats, effective_rtt;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (_this.mod.stun.hasConnection(peerId)) {
                _context4.n = 1;
                break;
              }
              clearInterval(_this.monitors[peerId]);
              delete _this.monitors[peerId];
              return _context4.a(2);
            case 1:
              _context4.n = 2;
              return pc.getStats();
            case 2:
              stats = _context4.v;
              stats.forEach(function (value, key) {
                if (value.type == 'remote-inbound-rtp' && value.kind == 'video') {
                  var rP = value.packetsReceived || 0;
                  var rL = value.packetsLost || 0;
                  my_stats.jitter = value.jitter * 1000 || 0;
                  my_stats.packetLoss = rL / (rP + rL) || 0;
                  my_stats.rtt = value.roundTripTime * 1000 || 0;
                }
              });

              //
              // Formula based on medium post of pseudocode of VLprojects/webrtc-issue-detector
              //
              effective_rtt = my_stats.rtt + my_stats.jitter * 2 + 10;
              if (effective_rtt < 160) {
                my_stats.rFactor = 93.2 - effective_rtt / 40;
              } else {
                my_stats.rFactor = 93.2 - effective_rtt / 120 - 10;
              }
              my_stats.rFactor = my_stats.rFactor - my_stats.packetLoss * 2.5;
              my_stats.rFactor = Math.max(my_stats.rFactor, 0);
              my_stats.mos = 1 + 0.035 * my_stats.rFactor + 0.000007 * my_stats.rFactor * (my_stats.rFactor - 60) * (100 - my_stats.rFactor);

              /*console.log(`STUN STATS [${peerId}]: `, my_stats);*/

              app.connection.emit('videocall-connection-strength', peerId, my_stats.mos);
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      })), 1000);
    });
    app.connection.on('stun-update-connection-message', function (peerId, connectionState) {
      if (_this.active) {
        _this.broadcastPeerList();
      }
    });
    app.connection.on('stun-track-event', function (peerId, event) {
      var _event$streams, _remoteStream$getAudi;
      //
      // Note: This happens twice because audio and video are added separately as mediaTracks...
      //
      // Talk sends microphone/camera tracks without a stream association and
      // screen-share tracks with their presentationStream. A presenter can
      // still send new call tracks (e.g. when another participant joins).
      var id = peerId === _this.mod.screen_share && event !== null && event !== void 0 && (_event$streams = event.streams) !== null && _event$streams !== void 0 && _event$streams.length ? 'presentation' : peerId;
      var remoteStream;
      if (event !== null && event !== void 0 && event.streams && event.streams[0]) {
        remoteStream = event.streams[0];
      } else {
        remoteStream = _this.remoteStreams.has(id) ? _this.remoteStreams.get(id) : new MediaStream();
        remoteStream.addTrack(event.track);
      }
      console.info('TALK [stun-track-event]: remote stream (track) added for', id, event.track, event.streams);
      _this.remoteStreams.set(id, remoteStream);
      _this.app.connection.emit('videocall-stream', id, remoteStream);
      if (!_this.active) {
        console.warn('STUN/TALK: Receiving media tracks before in call state');
        return;
      }

      // Update interface / video element
      _this.app.connection.emit('add-remote-stream-request', id, remoteStream);
      if ((_remoteStream$getAudi = remoteStream.getAudioTracks()) !== null && _remoteStream$getAudi !== void 0 && _remoteStream$getAudi.length) {
        _this.analyzeAudio(remoteStream, peerId);
      }
    });

    //Launch the Stun call
    app.connection.on('start-stun-call', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var sound;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _this.active = true;
            _this.leaving = false;
            _this.app.browser.lockNavigation(_this.visibilityChange.bind(_this), true);
            console.info('TALK [start-stun-call]', JSON.parse(JSON.stringify(_this.mod.room_obj)));
            _this.firstConnect = true;

            //Render the UI component
            _this.app.connection.emit('show-call-interface', _this.videoEnabled, _this.audioEnabled);
            _context5.n = 1;
            return _this.getLocalMedia();
          case 1:
            _this.mod.sendCallEntryTransaction();
            sound = new Audio('/saito/sound/Calm.mp3');
            sound.play();
            _this.analyzeAudio(_this.localStream, 'local');

            // Reattach remote-streams if necesssary
            console.info('TALK [StreamManager] restore remote streams....');

          /*this.remoteStreams.forEach((stream, id) => {
            console.info('TALK [StreamManager] cached stream for ' + id, stream);
            this.app.connection.emit('add-remote-stream-request', id, stream);
            //analyze audio..., maybe?
          });*/
          case 2:
            return _context5.a(2);
        }
      }, _callee5);
    })));
    app.connection.on('stun-new-peer-connection', /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(publicKey, peerConnection) {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (_this.active) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              console.info('TALK [stun-new-peer-connection]: ' + publicKey);
              console.debug(JSON.parse(JSON.stringify(_this.mod.room_obj)));
              if (!_this.mod.room_obj.call_peers.includes(publicKey)) {
                _context7.n = 3;
                break;
              }
              // Show status even if capture or signaling fails before media arrives.
              if (!_this.remoteStreams.has(publicKey)) {
                _this.app.connection.emit('add-remote-stream-request', publicKey, null);
              }
              peerConnection.firstConnect = true;
              _context7.n = 2;
              return _this.getLocalMedia();
            case 2:
              setTimeout(function () {
                var currentConnection = function currentConnection() {
                  return _this.active && _this.mod.stun.peers.get(publicKey) === peerConnection && peerConnection.signalingState !== 'closed';
                };
                if (!currentConnection() || !_this.localStream) return;
                try {
                  _this.localStream.getTracks().forEach(function (track) {
                    var _this$mod$diagnostics3;
                    // Discovery and connection reuse can notify us more than once.
                    if (peerConnection.getSenders().some(function (sender) {
                      return sender.track === track;
                    })) return;
                    console.info('TALK [stun-new-peer-connection] sending new track to ' + publicKey, track);
                    peerConnection.addTrack(track);
                    (_this$mod$diagnostics3 = _this.mod.diagnostics) === null || _this$mod$diagnostics3 === void 0 || _this$mod$diagnostics3.record(publicKey, "Attached local ".concat(track.kind, " track"));
                  });
                } catch (err) {
                  var _this$mod$diagnostics4;
                  (_this$mod$diagnostics4 = _this.mod.diagnostics) === null || _this$mod$diagnostics4 === void 0 || _this$mod$diagnostics4.record(publicKey, "Attach media failed: ".concat(err.name));
                  console.error(err);
                }
                if (_this.presentationStream) {
                  setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
                    return _regenerator().w(function (_context6) {
                      while (1) switch (_context6.n) {
                        case 0:
                          if (!(!currentConnection() || !_this.presentationStream)) {
                            _context6.n = 1;
                            break;
                          }
                          return _context6.a(2);
                        case 1:
                          _context6.n = 2;
                          return _this.mod.sendOffChainMessage('screen-share-start', {});
                        case 2:
                          if (!(!currentConnection() || !_this.presentationStream)) {
                            _context6.n = 3;
                            break;
                          }
                          return _context6.a(2);
                        case 3:
                          _this.presentationStream.getTracks().forEach(function (track) {
                            if (peerConnection.getSenders().some(function (sender) {
                              return sender.track === track;
                            })) return;
                            peerConnection.addTrack(track, _this.presentationStream);
                          });
                        case 4:
                          return _context6.a(2);
                      }
                    }, _callee6);
                  })), 1500);
                }
              }, 750);
            case 3:
              return _context7.a(2);
          }
        }, _callee7);
      }));
      return function (_x, _x2) {
        return _ref6.apply(this, arguments);
      };
    }());
    app.connection.on('stun-disconnect', function () {
      var _this$mod$CallInterfa;
      if (!_this.active) {
        return;
      }
      console.info('TALK [stun-disconnect]: hanging up...');
      _this.app.keychain.addKey(_this.mod.room_obj.call_id, {
        ended: true
      });

      // Programatic -- also triggered by navigating or refreshing!
      _this.leaveCall();
      if ((_this$mod$CallInterfa = _this.mod.CallInterface) !== null && _this$mod$CallInterfa !== void 0 && _this$mod$CallInterfa.close) {
        _this.mod.CallInterface.close();
      }
    });
  }
  return _createClass(StreamManager, [{
    key: "parseSettings",
    value: function parseSettings(settings) {
      this.videoEnabled = false;

      // Check saved options (maybe redundant...)

      if (settings !== null && settings !== void 0 && settings.video) {
        this.videoEnabled = true;
        if (settings.video !== true) {
          this.videoSource = settings.video;
        }
      }
      this.audioEnabled = false;
      if (settings !== null && settings !== void 0 && settings.audio) {
        this.audioEnabled = true;
        if (settings.audio !== true) {
          this.audioSource = settings.audio;
        }
      }
      this.auto_disconnect = (this === null || this === void 0 ? void 0 : this.auto_disconnect) || (settings === null || settings === void 0 ? void 0 : settings.auto_disconnect);
    }
  }, {
    key: "updateInputs",
    value: function updateInputs(type, source) {
      if (type == 'video') {
        this.videoSource = source;
        this.videoEnabled = true;
      } else {
        this.audioSource = source;
        this.audioEnabled = true;
      }
      this.app.options.stun.settings["preferred_".concat(type)] = source;
      this.app.storage.saveOptions();
      if (this.localStream) {
        console.debug('TALK [updateInputs]: ', type, source);
        this.localStream.getTracks().forEach(function (track) {
          track.stop();
        });
        this.localStream = null;
        this.getLocalMedia();
      }
    }
  }, {
    key: "returnConstraints",
    value: function returnConstraints() {
      var onlyVideo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var constraints = {};
      if (this.videoSource) {
        constraints.video = {
          deviceId: this.videoSource
        };
      } else if (this.videoEnabled) {
        constraints.video = true;
      } else {
        constraints.video = false;
      }
      if (!onlyVideo) {
        if (this.audioSource) {
          constraints.audio = {
            deviceId: this.audioSource
          };
        } else {
          constraints.audio = true;
        }
      }
      return constraints;
    }
  }, {
    key: "getLocalMedia",
    value: function () {
      var _getLocalMedia = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this$mod$diagnostics5,
          _this2 = this,
          _this$mod$diagnostics8;
        var shouldReturn, c, _this$mod$diagnostics6, _this$mod$diagnostics7, _t3, _t4;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              if (!this.localStream) {
                _context8.n = 1;
                break;
              }
              shouldReturn = true;
              this.localStream.getTracks().forEach(function (track) {
                if (track.readyState === 'ended') {
                  console.warn('TALK [getLocalMedia]: Track ready state is ended, reacquiring media...');
                  shouldReturn = false;
                }
              });
              if (!shouldReturn) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2);
            case 1:
              c = this.returnConstraints();
              console.debug('TALK [getLocalMedia]: ', this.videoSource, this.audioSource, c);
              (_this$mod$diagnostics5 = this.mod.diagnostics) === null || _this$mod$diagnostics5 === void 0 || _this$mod$diagnostics5.record('local', "Requesting media: video=".concat(!!c.video, ", audio=").concat(!!c.audio));
              //Get my local media
              _context8.p = 2;
              _context8.n = 3;
              return navigator.mediaDevices.getUserMedia(c);
            case 3:
              this.localStream = _context8.v;
              _context8.n = 8;
              break;
            case 4:
              _context8.p = 4;
              _t3 = _context8.v;
              console.warn('TALK [getLocalMedia] Problem attempting to get User Media', _t3);
              (_this$mod$diagnostics6 = this.mod.diagnostics) === null || _this$mod$diagnostics6 === void 0 || _this$mod$diagnostics6.record('local', "Media capture failed: ".concat(_t3.name, "; retrying audio only"));
              this.videoEnabled = false;
              c.video = false;
              _context8.p = 5;
              _context8.n = 6;
              return navigator.mediaDevices.getUserMedia(c);
            case 6:
              this.localStream = _context8.v;
              _context8.n = 8;
              break;
            case 7:
              _context8.p = 7;
              _t4 = _context8.v;
              (_this$mod$diagnostics7 = this.mod.diagnostics) === null || _this$mod$diagnostics7 === void 0 || _this$mod$diagnostics7.record('local', "Audio capture failed: ".concat(_t4.name));
              throw _t4;
            case 8:
              if (this.videoEnabled) {
                this.localStream.getVideoTracks().forEach(function (track) {
                  track.applyConstraints({
                    width: {
                      min: 640,
                      /*ideal: 900,*/max: 1280
                    },
                    height: {
                      min: 400,
                      max: 720
                    },
                    aspectRatio: {
                      ideal: 1.333333
                    }
                  });
                });
              }
              this.localStream.getAudioTracks().forEach(function (track) {
                track.enabled = _this2.audioEnabled;
              });
              (_this$mod$diagnostics8 = this.mod.diagnostics) === null || _this$mod$diagnostics8 === void 0 || _this$mod$diagnostics8.record('local', "Captured ".concat(this.localStream.getAudioTracks().length, " audio / ").concat(this.localStream.getVideoTracks().length, " video tracks"));
              //Plug local stream into UI component
              this.app.connection.emit('videocall-stream', 'local', this.localStream);
              this.app.connection.emit('add-local-stream-request', this.localStream);
            case 9:
              return _context8.a(2);
          }
        }, _callee8, this, [[5, 7], [2, 4]]);
      }));
      function getLocalMedia() {
        return _getLocalMedia.apply(this, arguments);
      }
      return getLocalMedia;
    }()
  }, {
    key: "setTranscribing",
    value: function setTranscribing(enabled) {
      if (!this.active) return;
      this.updateTranscriptionStatus(this.mod.publicKey, enabled);
      this.broadcastTranscriptionStatus();
    }
  }, {
    key: "broadcastTranscriptionStatus",
    value: function broadcastTranscriptionStatus() {
      void this.mod.sendOffChainMessage('toggle-transcription', {
        enabled: this.transcribingPeers.has(this.mod.publicKey)
      })["catch"](function (error) {
        return console.error('TALK: Could not share transcription status', error);
      });
    }
  }, {
    key: "updateTranscriptionStatus",
    value: function updateTranscriptionStatus(peer, enabled) {
      if (enabled) this.transcribingPeers.add(peer);else this.transcribingPeers["delete"](peer);
      this.app.connection.emit('peer-toggle-transcription-status', {
        public_key: peer,
        enabled: enabled
      });
    }
  }, {
    key: "removePeer",
    value: function removePeer(peer) {
      var _this3 = this;
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'left the meeting';
      this.updateTranscriptionStatus(peer, false);
      this.app.connection.emit('videocall-peer-left', peer);
      this.remoteStreams["delete"](peer);
      if (this.auto_disconnect) {
        siteMessage("".concat(this.app.keychain.returnUsername(peer), " hung up"), 1500);
        setTimeout(function () {
          _this3.app.connection.emit('stun-disconnect');
        }, 1500);
      } else {
        siteMessage("".concat(this.app.keychain.returnUsername(peer), " ").concat(message), 2500);
        //this.app.connection.emit("stun-switch-view");
      }
      var sound = new Audio('/saito/sound/Sharp.mp3');
      sound.play();
      this.broadcastPeerList();
    }
  }, {
    key: "leaveCall",
    value: function () {
      var _leaveCall = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var completion, sound;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              if (!(this.leaving || !this.active)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              this.leaving = true;
              completion = [];
              this.app.connection.emit('videocall-ended', completion);
              // Let transcript recognition drain and saving finish independently of hangup.
              void Promise.allSettled(completion);
              this.app.browser.unlockNavigation(this.visibilityChange.bind(this));
              this.endPresentation();
              _context9.n = 2;
              return this.mod.sendCallDisconnectTransaction();
            case 2:
              if (this.localStream) {
                this.localStream.getTracks().forEach(function (track) {
                  track.stop();
                  console.debug('TALK [leaveCall]: stopping track');
                });
              }
              this.localStream = null; //My Video Feed

              this.app.connection.emit('reset-stun');

              //
              // Reset parameters
              //
              this.videoEnabled = true;
              this.audioEnabled = true;
              this.auto_disconnect = false;
              this.transcribingPeers.clear();
              this.active = false;
              if (this.audioStreamAnalysis) {
                clearInterval(this.audioStreamAnalysis);
                this.audioStreamAnalysis = null;
              }
              console.info('TALK [leaveCall]: successfully disconnected...');
              sound = new Audio('/saito/sound/Sharp.mp3');
              sound.play();
            case 3:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function leaveCall() {
        return _leaveCall.apply(this, arguments);
      }
      return leaveCall;
    }()
  }, {
    key: "analyzeAudio",
    value: function analyzeAudio(stream, peer) {
      /*  
      let peer_manager_self = this;
       const audioContext = new AudioContext();
      const source = audioContext.createMediaStreamSource(stream);
      const analyser = audioContext.createAnalyser();
      source.connect(analyser);
      analyser.fftSize = 512;
      const bufferLength = analyser.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);
       let has_mike = false;
      const threshold = 20;
       function update() {
        analyser.getByteFrequencyData(dataArray);
        const average = dataArray.reduce((a, b) => a + b) / bufferLength;
         if (average > threshold && !has_mike) {
          this.current_speaker = peer;
           setTimeout(() => {
            if (peer === this.current_speaker) {
              peer_manager_self.app.connection.emit('stun-new-speaker', peer);
              has_mike = true;
            }
          }, 1000);
        } else if (average <= threshold) {
          has_mike = false;
        }
      }
      this.audioStreamAnalysis = setInterval(update, 1000);
      */
    }
  }, {
    key: "endPresentation",
    value: function endPresentation() {
      if (this.mod.screen_share === true) {
        var _this$app$options$stu;
        console.info('TALK [endPresentation] Screen sharing stopped by user');
        this.app.connection.emit('remove-peer-box', 'presentation');
        this.app.connection.emit('stun-switch-view', ((_this$app$options$stu = this.app.options.stun.settings) === null || _this$app$options$stu === void 0 ? void 0 : _this$app$options$stu.layout) || this.mod.layout);
        this.mod.screen_share = null;

        //
        // Reset the button here (not in the stop-share-screen handler) so the
        // browser's native "Stop sharing" bar resets it too
        //
        this.app.connection.emit('toggle-screen-share-label', false);
        this.mod.sendOffChainMessage('screen-share-stop');
      }
      if (this.presentationStream) {
        this.presentationStream.getTracks().forEach(function (track) {
          return track.stop();
        });
        this.presentationStream = null;
      }
    }
  }, {
    key: "broadcastPeerList",
    value: function broadcastPeerList() {
      var _this4 = this;
      var peer_list = {};
      this.mod.stun.peers.forEach(function (pc, address) {
        if (_this4.mod.room_obj.call_peers.includes(address)) {
          peer_list[address] = pc.connectionState;
        }
      });
      this.mod.sendOffChainMessage('broadcast-call-list', peer_list);
    }
  }, {
    key: "visibilityChange",
    value: function visibilityChange() {
      this.leaveCall();
    }
  }]);
}();
module.exports = StreamManager;